/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios"
import { IAooProtocolView } from "../shared/interfaces";

const controller = 'AooProtocolViews';

const getAooProtocolViews = (aooId: number, cancelToken?: CancelToken): Promise<IAooProtocolView[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetAooProtocolViews`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const getAooProtocolView = (aooId: number, viewId: number, cancelToken?: CancelToken): Promise<IAooProtocolView> => {
    return axiosInstance.get(`${controller}/${aooId}/GetAooProtocolView/${viewId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const update = (aooId: number, viewId: number, view: Partial<IAooProtocolView>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.put(`${controller}/${aooId}/Update/${viewId}`, view, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    getAooProtocolViews,
    getAooProtocolView,
    update,
}
